<div class="hr-calendar-header">
  <button type="button"
          class="btn btn-plain-default hr-calendar-header__nav"
          test-id="hr-calendar-previous-month"
          [attr.aria-label]="'HR_CALENDAR.previous_month' | translate"
          (click)="previous.emit()">
    <em class="fa fa-light fa-chevron-left" aria-hidden="true"></em>
  </button>
  <button #monthPopover="bs-popover"
          type="button"
          class="btn btn-plain-default hr-calendar-header__month"
          test-id="hr-calendar-month-label"
          aria-haspopup="dialog"
          [attr.aria-expanded]="isPickerOpen"
          [attr.aria-label]="('HR_CALENDAR.select_month' | translate) + ', ' + monthLabel"
          [popover]="monthPickerTemplate"
          [outsideClick]="true"
          placement="bottom"
          container="body"
          containerClass="hr-calendar-month-picker-popover"
          (onShown)="setPickerOpen(true)"
          (onHidden)="setPickerOpen(false)"
          (keydown.escape)="closePicker()">
    <span class="hr-calendar-header__month-label">{{ monthLabel }}</span>
    <em class="fa fa-light fa-chevron-down" aria-hidden="true"></em>
  </button>
  <button type="button"
          class="btn btn-plain-default hr-calendar-header__nav"
          test-id="hr-calendar-next-month"
          [attr.aria-label]="'HR_CALENDAR.next_month' | translate"
          (click)="next.emit()">
    <em class="fa fa-light fa-chevron-right" aria-hidden="true"></em>
  </button>
</div>

<ng-template #monthPickerTemplate>
  <div role="dialog"
       [attr.aria-label]="'HR_CALENDAR.select_month' | translate"
       (keydown.escape)="closePicker()">
    <gp-hr-calendar-month-picker
      [selected]="viewDate"
      (monthSelected)="onMonthSelected($event)">
    </gp-hr-calendar-month-picker>
  </div>
</ng-template>

